<template>
  <div>
    <strong class="text-error">{{ $t('global.basicTerms.caution').toUpperCase() }}:</strong>
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>
